export function normalizeSearchInput(value: unknown): string {
  return String(value ?? '').trim().toLowerCase();
}

// match без учета регистра
export function startsWithIgnoreCase(value: unknown, prefix: unknown): boolean {
  const normalizedValue = normalizeSearchInput(value);
  const normalizedPrefix = normalizeSearchInput(prefix);

  if (!normalizedPrefix) return true;
  return normalizedValue.startsWith(normalizedPrefix);
}

// точное совпадение с учетом регистра
export function isExactMatch(value: unknown, prefix: unknown): boolean {
  return String(value ?? '').trim() === String(prefix ?? '').trim();
}
